import modelAttribute from '../assets/new-ui/about-nft/model-attribute-new.png'
import modelAttributeMobilePart1 from '../assets/new-ui/about-nft/model-attribute-mobile-part-1-new.png'
import modelAttributeMobilePart2 from '../assets/new-ui/about-nft/model-attribute-mobile-part-2-new.png'

export default function Attribute() {
  return (
     <div className='attributeContainer'>
       <div className='attributeTitle'>Attributes</div>
       <div className='attributeDescription'>Below is a list of some of the the attributes that each Holy Shark can have:</div>
       <div className='modelAttribute'>
        <img src={modelAttribute} alt='attribute model' />
        {/* <div className='smallPart chain'>Chain, Fanged Injury, Rain Doll, Fin on Fire, Starfall, Scars, Bandage, etc.</div> */}
        <div className='bigPart glasses'>Glasses</div>
        <div className='bigPart hat'>Hat</div>
        {/* <div className='bigPart mouth'>Mouth type, Eyes type.</div> */}
        {/* <div className='bigPart blade'>Blade, Trident, Lamp, Bow, Stick, Spear, etc.</div> */}
        <div className='bigPart suit'>Suit</div>
        <div className='bigPart shoes'>Shoes</div>
        <div className='bigPart necklace'>Necklace</div>
        <div className='bigPart bracelets'>Bracelets</div>
        <div className='bigPart tail'>Tail</div>
        {/* <div className='smallPart dragon'>Dragon Wings, Demon Wings, Fairy Wings, Bat Wings, etc.</div> */}

        <div className='bigPart fin'>Fin type</div>
        <div className='bigPart facial'>Facial Features</div>
        <div className='bigPart weapon'>Weapon</div>
        <div className='bigPart wings'>Wings type</div>

        <div className='groupParts'>
          <div className='elementPart'>
            <div>Body type</div>
            {/* <div>Water Skin, Fairy Skin, Ghost Skin, etc.</div> */}
          </div>

          <div className='elementPart'>
            <div>Place of birth</div>
            {/* <div>Mediterranean Sea, Olympus Peak, Tartarus, Pantheon Temple, Abyss, Milot Island, Delight Island, Ortrus Mountain, etc</div> */}
          </div>
        </div>

       </div>

       <div className='modelAttributeMobile'>
          <div className='modelAttributePart'>
            <img src={modelAttributeMobilePart1} alt='attribute model' />
            <div className='modelAttributeList'>
              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>1</div>
                  <div>Fin type</div>
                </div>
                {/* <div className='modelAttributeMore'>Chain, Fanged Injury, Rain Doll, Fin on Fire, Starfall, Scars, Bandage, etc.</div> */}
              </div>
              
              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>2</div>
                  <div>Glasses</div>
                </div>
              </div>

              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>3</div>
                  <div>Wings type</div>
                </div>
                {/* <div className='modelAttributeMore'>Dragon Wings, Demon Wings, Fairy Wings, Bat Wings, etc.</div> */}
              </div>

              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>4</div>
                  <div>Fin type</div>
                </div>
              </div>

              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>5</div>
                  <div>Bracelets</div>
                </div>
              </div>

              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>6</div>
                  <div>Tail</div>
                </div>
              </div>

              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>7</div>
                  <div>Shoes</div>
                </div>
              </div>

            </div>
          </div>

          <div className='modelAttributePart'>
            <img src={modelAttributeMobilePart2} alt='attribute model' />
            <div className='modelAttributeList'>
              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>8</div>
                  <div>Hat</div>
                </div>
              </div>
              
              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>9</div>
                  <div>Facial Features</div>
                </div>
                {/* <div className='modelAttributeMore'>Mouth type, Eyes type.</div> */}
              </div>

              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>10</div>
                  <div>Weapon</div>
                </div>
                {/* <div className='modelAttributeMore'>Blade, Trident, Lamp, Bow, Stick, Spear, etc.</div> */}
              </div>

              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>11</div>
                  <div>Suit</div>
                </div>
              </div>

              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>12</div>
                  <div>Body type</div>
                </div>
                {/* <div className='modelAttributeMore'>Water Skin, Fairy Skin, Ghost Skin, etc.</div> */}
              </div>

              <div className='modelAttributeElement'>
                <div className='modelAttributeDetail'>
                  <div>13</div>
                  <div>Place of birth</div>
                </div>
              </div>
              {/* <div className='modelAttributeMore'>Mediterranean Sea, Olympus Peak, Tartarus, Pantheon Temple, Abyss, Milot Island, Delight Island, Ortrus Mountain, etc</div> */}
            </div>
          </div>

       </div>
     </div>
  )
}